/**
 * tdesign v1.6.6
 * (c) 2023 tdesign
 * @license MIT
 */

import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { defineComponent, computed } from '@vue/composition-api';
import Item from './Item.js';
import props from '../props.js';
import { usePrefixClass } from '../../hooks/useConfig.js';
import { useTNodeDefault } from '../../hooks/tnode.js';
import { getDefaultNode } from '../../hooks/render-tnode.js';
import { getPanels } from '../core/helper.js';
import { expendClickEffect, valueChangeEffect } from '../core/effect.js';
import { useConfig } from '../../config-provider/useConfig.js';
import '../../_chunks/dep-1461d230.js';
import 'tdesign-icons-vue';
import '../core/className.js';
import '@babel/runtime/helpers/toConsumableArray';
import '../../checkbox/index.js';
import '../../checkbox/group.js';
import '@babel/runtime/helpers/typeof';
import '@babel/runtime/helpers/slicedToArray';
import 'lodash/intersection';
import 'lodash/isObject';
import 'lodash/isUndefined';
import '../../checkbox/checkbox.js';
import '../../checkbox/props.js';
import '../../hooks/index.js';
import '../../utils/render-tnode.js';
import 'vue';
import 'lodash/camelCase';
import 'lodash/kebabCase';
import '../../hooks/slots.js';
import 'lodash/isArray';
import '../../hooks/useCommonClassName.js';
import '../../config-provider/context.js';
import 'lodash/merge';
import 'lodash/mergeWith';
import '../../_common/js/global-config/default-config.js';
import '../../_common/js/global-config/locale/zh_CN.js';
import '../../_chunks/dep-fdafdce0.js';
import 'dayjs';
import '../../_chunks/dep-9849f16c.js';
import '../../config-provider/type.js';
import '../../hooks/useDefaultValue.js';
import '../../hooks/useDestroyOnClose.js';
import '../../hooks/useElementLazyRender.js';
import '../../_common/js/utils/observe.js';
import '../../hooks/useFormDisabled.js';
import '../../hooks/useGlobalIcon.js';
import '../../hooks/useLazyLoad.js';
import '../../hooks/useResizeObserver.js';
import '../../hooks/useVirtualScrollNew.js';
import '../../hooks/useVModel.js';
import '../../hooks/useImagePreviewUrl.js';
import '../../_common/js/upload/utils.js';
import '../../_common/js/log/log.js';
import '../../checkbox/constants.js';
import '../../checkbox/store.js';
import '@babel/runtime/helpers/classCallCheck';
import '@babel/runtime/helpers/createClass';
import '../../checkbox/hooks/useKeyboardEvent.js';
import '../../checkbox/checkbox-group-props.js';
import '../../utils/withInstall.js';
import 'lodash/capitalize';
import './style/css.js';
import '../../checkbox/type.js';
import '../../loading/index.js';
import '../../loading/directive.js';
import 'lodash/mapKeys';
import 'lodash/isEqual';
import '../../loading/plugin.js';
import '../../loading/loading.js';
import '../../loading/icon/gradient.js';
import '../../_common/js/loading/circle-adapter.js';
import '../../_common/js/utils/set-style.js';
import '../../_common/js/utils/helper.js';
import '@babel/runtime/helpers/objectWithoutProperties';
import 'lodash/isString';
import 'lodash/isNull';
import 'lodash/isNumber';
import '../../config-provider/config-receiver.js';
import '../../utils/mixins.js';
import '../../utils/dom.js';
import 'raf';
import '../../utils/easing.js';
import '../../utils/transfer-dom.js';
import '../../loading/props.js';
import '../../config.js';
import '../../loading/type.js';
import '../../utils/ripple.js';
import 'lodash/isEmpty';
import 'lodash/isFunction';
import 'lodash/cloneDeep';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Panel = defineComponent({
  name: "TCascaderSubPanel",
  props: {
    option: props.option,
    empty: props.empty,
    trigger: props.trigger,
    onChange: props.onChange,
    loading: props.loading,
    loadingText: props.loadingText,
    cascaderContext: {
      type: Object
    }
  },
  setup: function setup(props, _ref) {
    var _treeStore$config;
    var emit = _ref.emit;
    var renderTNodeJSXDefault = useTNodeDefault();
    var COMPONENT_NAME = usePrefixClass("cascader");
    var _useConfig = useConfig("cascader"),
      global = _useConfig.global;
    var _props$cascaderContex = props.cascaderContext,
      valueType = _props$cascaderContex.valueType,
      cascaderValue = _props$cascaderContex.cascaderValue,
      treeStore = _props$cascaderContex.treeStore,
      multiple = _props$cascaderContex.multiple;
    var panels = computed(function () {
      return getPanels(props.cascaderContext.treeNodes);
    });
    var handleExpand = function handleExpand(node, trigger) {
      var propsTrigger = props.trigger,
        cascaderContext = props.cascaderContext;
      expendClickEffect(propsTrigger, trigger, node, cascaderContext);
    };
    if (treeStore !== null && treeStore !== void 0 && (_treeStore$config = treeStore.config) !== null && _treeStore$config !== void 0 && _treeStore$config.load && valueType === "full" && cascaderValue.length > 0) {
      var firstValue = multiple ? cascaderValue[0][0] : cascaderValue[0];
      var firstExpandNode = treeStore.nodes.find(function (node) {
        return node.value === firstValue;
      });
      handleExpand(firstExpandNode, "click");
    }
    return {
      global: global,
      panels: panels,
      handleExpand: handleExpand,
      renderTNodeJSXDefault: renderTNodeJSXDefault,
      COMPONENT_NAME: COMPONENT_NAME,
      emit: emit
    };
  },
  render: function render() {
    var _this = this;
    var h = arguments[0];
    var global = this.global,
      COMPONENT_NAME = this.COMPONENT_NAME,
      handleExpand = this.handleExpand,
      renderTNodeJSXDefault = this.renderTNodeJSXDefault,
      cascaderContext = this.cascaderContext,
      panels = this.panels,
      emit = this.emit;
    var renderItem = function renderItem(node, index) {
      var optionChild = node.data.content ? getDefaultNode(node.data.content(_this.$createElement)) : renderTNodeJSXDefault("option", {
        params: {
          item: node.data,
          index: index
        }
      });
      return h(Item, {
        "key": node.value,
        "attrs": {
          "node": node,
          "cascaderContext": cascaderContext
        },
        "props": _objectSpread({}, {
          node: node,
          optionChild: optionChild,
          cascaderContext: cascaderContext,
          onClick: function onClick() {
            emit("click", node.value, node);
            handleExpand(node, "click");
          },
          onMouseenter: function onMouseenter() {
            handleExpand(node, "hover");
          },
          onChange: function onChange() {
            valueChangeEffect(node, cascaderContext);
          }
        })
      });
    };
    var renderList = function renderList(treeNodes) {
      var _ref2;
      var isFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var segment = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
      return h("ul", {
        "class": ["".concat(COMPONENT_NAME, "__menu"), "narrow-scrollbar", (_ref2 = {}, _defineProperty(_ref2, "".concat(COMPONENT_NAME, "__menu--segment"), segment), _defineProperty(_ref2, "".concat(COMPONENT_NAME, "__menu--filter"), isFilter), _ref2)],
        "key": "".concat(COMPONENT_NAME, "__menu").concat(index)
      }, [treeNodes.map(function (node) {
        return renderItem(node, index);
      })]);
    };
    var renderEmpty = function renderEmpty() {
      if (_this.empty && typeof _this.empty === "string") {
        return h("div", {
          "class": "".concat(COMPONENT_NAME, "__panel--empty")
        }, [_this.empty]);
      }
      return renderTNodeJSXDefault("empty", h("div", {
        "class": "".concat(COMPONENT_NAME, "__panel--empty")
      }, [global.empty]));
    };
    var renderPanels = function renderPanels() {
      var inputVal = cascaderContext.inputVal,
        treeNodes = cascaderContext.treeNodes;
      return inputVal ? renderList(treeNodes, true) : panels.map(function (treeNodes2, index) {
        return renderList(treeNodes2, false, index !== panels.length - 1, index);
      });
    };
    var content;
    if (this.loading) {
      content = renderTNodeJSXDefault("loadingText", h("div", {
        "class": "".concat(COMPONENT_NAME, "__panel--empty")
      }, [global.loadingText]));
    } else {
      content = panels.length ? renderPanels() : renderEmpty();
    }
    return h("div", {
      "class": ["".concat(COMPONENT_NAME, "__panel"), _defineProperty({}, "".concat(COMPONENT_NAME, "--normal"), panels.length && !this.loading)]
    }, [content]);
  }
});

export { Panel as default };
//# sourceMappingURL=Panel.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-vue/es/cascader/components/Panel.js
// module id = null
// module chunks = 